const base = {
   
    loginPage:"/api/mgr/signin",
    dataPage:"/api/mgr/customers"
}
export default  base;